import { useEffect, useState } from "react";
import api, { fmtNum, fmt, API } from "@/lib/api";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";

const currentFy = () => {
    const d = new Date();
    return d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
};
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const monthLabel = (m) => MONTHS[Number(m.slice(5, 7)) - 1];

export const YearlyExpenseReport = () => {
    const [fy, setFy] = useState(currentFy);
    const [data, setData] = useState(null);
    useEffect(() => {
        let live = true;
        setData(null);
        api.get("/expenses/yearly", { params: { fy } })
            .then((r) => live && setData(r.data))
            .catch((e) => toast.error(e.response?.data?.detail || "Couldn't load report"));
        return () => { live = false; };
    }, [fy]);
    const years = Array.from({ length: 6 }, (_, i) => currentFy() - i);

    return (
        <div data-testid="yearly-report-tab">
            <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
                <div className="flex items-center gap-3">
                    <select value={fy} onChange={(e) => setFy(Number(e.target.value))}
                            className="hdb-input !w-40" data-testid="yearly-fy-select">
                        {years.map((y) => <option key={y} value={y}>FY {y}-{String(y + 1).slice(-2)}</option>)}
                    </select>
                    {data && (
                        <span className="text-sm text-slate-600" data-testid="yearly-grand">
                            Total <b className="hdb-num">{fmt(data.grand)}</b> · {data.count} approved entries
                        </span>
                    )}
                </div>
                <a href={`${API}/expenses/yearly.xlsx?fy=${fy}`} className="hdb-btn hdb-btn-ghost"
                   data-testid="yearly-export-xlsx"><Download size={13}/> Excel for CA</a>
            </div>
            <div className="hdb-card overflow-x-auto">
                {!data ? (
                    <div className="p-10 text-center text-slate-400"><Loader2 className="inline animate-spin" size={14}/></div>
                ) : data.categories.length === 0 ? (
                    <div className="p-10 text-center text-slate-400" data-testid="yearly-empty">
                        No approved expenses in {data.label}.
                    </div>
                ) : (
                    <table className="hdb-table w-full text-xs" data-testid="yearly-table">
                        <thead><tr>
                            <th className="text-left sticky left-0 bg-white">Category</th>
                            {data.months.map((m) => <th key={m} className="text-right">{monthLabel(m)}</th>)}
                            <th className="text-right">Total</th>
                        </tr></thead>
                        <tbody>
                            {data.categories.map((c, i) => (
                                <tr key={c.name} data-testid={`yearly-row-${i}`}>
                                    <td className="font-bold sticky left-0 bg-white whitespace-nowrap">{c.name}</td>
                                    {data.months.map((m) => (
                                        <td key={m} className="hdb-num hdb-num-right text-slate-600">
                                            {c.by_month[m] ? fmtNum(c.by_month[m]) : <span className="text-slate-300">—</span>}
                                        </td>
                                    ))}
                                    <td className="hdb-num hdb-num-right font-black">{fmtNum(c.total)}</td>
                                </tr>
                            ))}
                            <tr className="bg-slate-50" data-testid="yearly-total-row">
                                <td className="font-black sticky left-0 bg-slate-50">TOTAL</td>
                                {data.months.map((m) => (
                                    <td key={m} className="hdb-num hdb-num-right font-bold">{fmtNum(data.month_totals[m])}</td>
                                ))}
                                <td className="hdb-num hdb-num-right font-black">{fmtNum(data.grand)}</td>
                            </tr>
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};
